export interface IFeedbackValidator {
  feedbackTypes: ILookupItem[]
  serviceAreaAi?: IServiceArea
}

export interface IFeedbackLookupData {
  serviceAreas: IServiceArea[]
  servicePoints: IServicePoint[]
  serviceIssues: IServiceIssue[]
  feedbackTypes: ILookupItem[]
  customerReferenceTypes: ILookupItem[]
  responseRequiredOptions: ILookupItem[]
}

export interface IServiceArea {
  id: string
  name: string
  servicePoints?: IServicePoint[]
}

export interface IServicePoint {
  id: string
  name: string
  serviceAreaId: string
  serviceIssues?: IServiceIssue[]
}

export interface IServiceIssue {
  id: string
  name: string
  servicePointd: string
}

export interface ILookupItem {
  id: string
  name: string
}

export interface IFeedback {
  feedbackTypeId: string
  serviceAreaId: string
  servicePointId: string
  serviceIssueId: string
  issue: string
  libraryPageReference: string
  customerReferenceTypeId: string
  responseRequired?: string
  accountEmail?: string
  crn?: string
  matterNumber?: string
  enquiryNumber?: string
  firstName?: string
  lastName?: string
  emailAddress?: string
  phoneNumber?: string
  decision?: string
  reasonBehindWrongDecision?: string
  evidenceForWrongDecision?: string
  expectedOutcome?: string
}

export class Feedback implements IFeedback {
  feedbackTypeId: string
  serviceAreaId: string
  servicePointId: string
  serviceIssueId: string
  issue: string
  libraryPageReference: string
  customerReferenceTypeId: string
  responseRequired?: string
  accountEmail?: string
  crn?: string
  matterNumber?: string
  enquiryNumber?: string
  firstName?: string
  lastName?: string
  emailAddress?: string
  phoneNumber?: string
  decision?: string
  reasonBehindWrongDecision?: string
  evidenceForWrongDecision?: string
  expectedOutcome?: string

  constructor(init?: FeedbackFormValues) {
    this.feedbackTypeId = init.feedbackTypeId
    this.serviceAreaId = init.serviceAreaId
    this.servicePointId = init.servicePointId
    this.serviceIssueId = init.serviceIssueId
    this.issue = init.issue
    this.libraryPageReference = init.libraryPageReference
    this.customerReferenceTypeId = init.customerReferenceTypeId
    this.responseRequired = init.responseRequired
    this.accountEmail = init.accountEmail
    this.crn = init.crn
    this.matterNumber = init.matterNumber
    this.enquiryNumber = init.enquiryNumber
    this.firstName = init.firstName
    this.lastName = init.lastName
    this.emailAddress = init.emailAddress
    this.phoneNumber = init.phoneNumber
    this.decision = init.decision
    this.reasonBehindWrongDecision = init.reasonBehindWrongDecision
    this.evidenceForWrongDecision = init.evidenceForWrongDecision
    this.expectedOutcome = init.expectedOutcome
  }
}

export class FeedbackFormValues {
  feedbackTypeId = ''
  serviceAreaId = ''
  servicePointId = ''
  serviceIssueId = ''
  issue = ''
  libraryPageReference = ''
  customerReferenceTypeId = ''
  responseRequired = ''
  accountEmail = ''
  crn = ''
  matterNumber = ''
  enquiryNumber = ''
  firstName = ''
  lastName = ''
  emailAddress = ''
  phoneNumber = ''
  decision = ''
  reasonBehindWrongDecision = ''
  evidenceForWrongDecision = ''
  expectedOutcome = ''
}

export enum FeedbackTypes {
  ProvideFeedback = 'Provide feedback',
  MakeComplaint = 'Make a complaint',
  RequestReviewDecision = 'Request a review of a decision',
}

export enum FeedbackReferenceTypes {
  MyAccount = 'My account',
  CRN = 'Customer Reference Number (CRN)',
  MatterNumber = 'Matter number',
  EnquiryNumber = 'Enquiry number',
  PreferNotToAnswer = 'Prefer not to answer',
  No = 'No',
}

export const FeedbackFieldMapping = new Map<string, string>([
  ['feedbackTypeId', 'I want to'],
  ['serviceAreaId', 'Service area'],
  ['servicePointId', 'My feedback is about'],
  ['serviceIssueId', 'Service Issue'],
  ['libraryPageReference', 'Library page reference'],
  ['customerReferenceTypeId', 'Do you have an account or reference with us?'],
  ['accountEmail', 'Please provide your My account email'],
  ['crn', 'Please provide your CRN'],
  ['matterNumber', 'Please provide your matter number'],
  ['enquiryNumber', 'Please provide your enquiry number'],
  ['responseRequired', 'Do you want a response to your feedback?'],
  ['firstName', 'First name'],
  ['lastName', 'Last name'],
  ['emailAddress', 'Email address'],
  ['phoneNumber', 'Phone number'],
  ['issue', 'Please provide more detail'],
  ['decision', 'What decision do you want reviewed?'],
  ['reasonBehindWrongDecision', 'Why do you think we made the wrong decision?'],
  [
    'evidenceForWrongDecision',
    'What evidence do you have that we made the wrong decision?',
  ],
  ['expectedOutcome', 'What outcome are you looking for? '],
])
